import React from "react";
import queryString from "query-string";

import { ResetPasswordForm } from "../Forms/Auth";

const ResetPasswordPage = () => {
  const search = window.location.search;
  const query = queryString.parse(search);
  return (
    <div className="ResetPasswordPage">
      <ResetPasswordForm token={query.token} />
    </div>
  );
};

export default ResetPasswordPage;
